export default {
    'SET_VALOR_CONTRIBUICAO_HOME' (state, payload) {
        state.valorContribuicaoHome = payload
    },
    'SET_USER' (state, payload) {
        state.user = payload
    },
    'SET_AUTH' (state, payload) {
        state.auth = payload
    },
    'SET_CARTAO_VIGENTE' (state, payload) {
        state.cartaoVigente = payload
    },
    'SET_CARRINHO' (state, payload) {
        state.carrinho = payload
    },
    'SET_CONFIRMACAO_PAGAMENTO' (state, payload) {
        state.confirmacaoPagamento = payload
    },
    'ADD_CARRINHO' (state, payload) {
        state.carrinho.push(payload)
    },
    'REMOVE_CARRINHO' (state, index) {
        state.carrinho.splice(index,1)
    },
    'SET_MENU' (state, payload) {
        state.menu = payload
    }
}


// WEBPACK FOOTER //
// ./src/vuex/mutations.js